module.exports = __webpack_public_path__ + "assets/img/twitter.9dd2959b.png";